/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import './CardInfobox.scss';
import {
  appCardStyle,
  appChipSize,
  appChipStyle,
  appIconsPath,
  appInfoCardSize,
  appLinkSize,
  appLinkStyle,
  getKeyByValue
} from '@utils/globalConstant';
import { Link } from '@core/Link';
import { Chip } from '@core/Chip';
import PropTypes from 'prop-types';
import { tA11y } from '@utils/a11y/a11yHelpers';
import Icons from '@core/Utils/Icons/Icons';

export function CardInfoboxChip({
  cardStyle = appCardStyle.DEFAULT,
  cardSize = appInfoCardSize.LARGE, // Text size
  chipStyle = appChipStyle.WHITE,
  chipIcon = null,
  chipLabel = '',
  text = '',
  redirectionLabel = '',
  redirectionIcon = appIconsPath.ARROW_RIGHT_SMALL,
  redirectionStyle = appLinkStyle.PRIMARY,
  handleRedirection = '#'
}) {
  const chipSize = cardSize === appInfoCardSize.DEFAULT ? appChipSize.DEFAULT : appChipSize.LARGE;
  const redirectionSize =
    cardSize === appInfoCardSize.DEFAULT ? appLinkSize.SMALL : appLinkSize.DEFAULT;
  const cardPadding = cardSize === appInfoCardSize.DEFAULT ? 'p-12' : 'p-16';

  return (
    <div className={`${cardStyle} ${cardSize} ${cardPadding}`}>
      <div className="row">
        <div className="col-12">
          <Chip chipStyle={chipStyle} chipSize={chipSize} icon={chipIcon} label={chipLabel} />
        </div>
        <div className="col-12 pt-12 pb-4">
          {tA11y(text).isHtml ? (
            <div
              className={`${cardSize} align-content-center`}
              dangerouslySetInnerHTML={{ __html: tA11y(text).content }}
            />
          ) : (
            <div className={`${cardSize} align-content-center`}>{tA11y(text).content}</div>
          )}
        </div>
        {redirectionLabel && (
          <div className="col-12">
            <Link
              label={redirectionLabel}
              iconRight={redirectionIcon}
              linkStyle={redirectionStyle}
              linkSize={redirectionSize}
              linkRef={handleRedirection}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export function CardInfobox({
  cardStyle = appCardStyle.DEFAULT,
  cardSize = appInfoCardSize.DEFAULT,
  cardIcon = null,
  text = '',
  cardAlt='',
  redirectionLabel = '',
  redirectionIcon = appIconsPath.ARROW_RIGHT_SMALL,
  redirectionStyle = appLinkStyle.PRIMARY,
  handleRedirection = '#'
}) {
  const iconHeight = cardSize === appInfoCardSize.DEFAULT ? 16 : 24;
  const redirectionSize =
    cardSize === appInfoCardSize.DEFAULT ? appLinkSize.SMALL : appLinkSize.DEFAULT;
  const cardPadding = cardSize === appInfoCardSize.DEFAULT ? 'p-12' : 'p-16';
  const icosName = getKeyByValue(appIconsPath,cardIcon);

  return (
    <div className={`${cardStyle} ${cardSize} ${cardPadding}`}>
      <div className="d-flex justify-content-start gap-12">
        <Icons name={icosName} alt={cardAlt} height={iconHeight} colorType='dark' />
        <div>
          {tA11y(text).isHtml ? (
            <div
              className={`${cardSize} align-content-center pb-4`}
              dangerouslySetInnerHTML={{ __html: tA11y(text).content }}
            />
          ) : (
            <div className={`${cardSize} align-content-center pb-4`}>
              {tA11y(text).content}
            </div>
          )}
          {redirectionLabel && (
            <Link
              label={redirectionLabel}
              iconRight={redirectionIcon}
              linkType={redirectionStyle}
              linkSize={redirectionSize}
              linkRef={handleRedirection}
            />
          )}
        </div>
      </div>
    </div>
  );
}

CardInfoboxChip.propTypes = {
  cardStyle: PropTypes.string,
  cardSize: PropTypes.string,
  chipStyle: PropTypes.string,
  chipIcon: PropTypes.string.isRequired,
  chipLabel: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  redirectionLabel: PropTypes.string,
  redirectionIcon: PropTypes.string,
  redirectionStyle: PropTypes.string,
  handleRedirection: PropTypes.func
};

CardInfobox.propTypes = {
  cardStyle: PropTypes.string,
  cardSize: PropTypes.string,
  cardIcon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  redirectionLabel: PropTypes.string,
  redirectionIcon: PropTypes.string,
  redirectionStyle: PropTypes.string,
  handleRedirection: PropTypes.func
};

export default CardInfobox;
